import { useState } from "react";
import SurveyIngestion from "@solimat/solimat-web-endpoint/lib/survey-ingestion";
import { ObtenerEncuestaResponse } from "@solimat/solimat-web-endpoint/lib/survey-ingestion/dto";

const useObtenerEncuestas = () => {
  const BASE_URL = import.meta.env.VITE_REACT_APP_ENCUESTAS_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_ENCUESTAS_KEY || "";
  const apiSurvey = new SurveyIngestion.SurveyIngestionService(BASE_URL, FUNCTIONS_KEY);

  const [loadingObtenerEncuestas, setLoadingObtenerEncuestas] = useState(false);
  const [successObtenerEncuestas, setSuccessObtenerEncuestas] = useState(false);
  const [errorObtenerEncuestas, setErrorObtenerEncuestas] = useState(null);
  const [encuestas, setEncuestas] = useState<ObtenerEncuestaResponse[]>([]);

  const obtenerEncuestas = async () => {
    setLoadingObtenerEncuestas(true);
    setErrorObtenerEncuestas(null);
    try {
      const res = await apiSurvey.obtenerEncuestas();
      setSuccessObtenerEncuestas(true);
      setLoadingObtenerEncuestas(false);
      const encuestas = ordenarEncuestas(res.data as ObtenerEncuestaResponse[]);
      setEncuestas(encuestas)
      return encuestas;
    }
    catch (err) {
      console.error("obtenerEncuestas error: ", err);
      setErrorObtenerEncuestas(err);
      setLoadingObtenerEncuestas(false);
    }
  };

  function ordenarEncuestas(encuestas: ObtenerEncuestaResponse[]): ObtenerEncuestaResponse[] {
    if (encuestas) {
      return encuestas
        .slice()
        .sort((a, b) => {
          if (a.caducada !== b.caducada) {
            return a.caducada ? 1 : -1;
          }
          
          const estadoDiff = a.estadoRespuesta - b.estadoRespuesta;
          if (estadoDiff !== 0) return estadoDiff;
          
          const fechaA = new Date(`${a.fechaCaducidadEfectiva}Z`).getTime();
          const fechaB = new Date(`${b.fechaCaducidadEfectiva}Z`).getTime();

          if (fechaA !== fechaB) {
            if (!a.caducada) {
              return fechaA - fechaB;
            }

            return fechaB - fechaA;
          }

          return b.prioridad - a.prioridad;
        })
        .map(encuesta => ({
          ...encuesta,
          categoriasPreguntas: encuesta.categoriasPreguntas
            .slice()
            .sort((a, b) => a.orden - b.orden)
            .map(categoria => ({
              ...categoria,
              preguntas: categoria.preguntas
                .slice()
                .sort((a, b) => a.orden - b.orden)
                .map(pregunta => ({
                  ...pregunta,
                  opciones: pregunta.opciones
                    .slice()
                    .sort((a, b) => a.orden - b.orden)
                }))
            }))
        }));
    }

    return [];
  }

  return {
    encuestas,
    obtenerEncuestas,
    successObtenerEncuestas,
    loadingObtenerEncuestas,
    errorObtenerEncuestas
  };
};

export default useObtenerEncuestas;